import { createBrowserHistory } from "history";
import React, { Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AuthRouteManager from "../../hoc/AuthRouteManager";
import { createBlogModal } from "../../redux/actions/blogAction";
import CreateBlog from "../medium/CreateBlog";
import { Login } from "../../components/Login";
import Home from "../../pages/Home";
import ViewPost from "../pages/ViewPost";
import Layout from "../parent/Layout";
import { ThemeProvider } from "styled-components";
import { theme } from "../../theme";
import { ProtectedRoute } from "./ProtectedRoute";
import UserDashboard from "../../pages/UserDashboard";
import Loader from "../mini/Loader";
import NewSearch from "../../pages/Search";
import RootModal from "../../shared/Modal/RootModal";

const Blogfolio = React.lazy(() => import("../../pages/Blogfolio"));
const CreatePost = React.lazy(() => import("../pages/CreatePost"));
const Chats = React.lazy(() => import("../../pages/Chats"));
const Notifications = React.lazy(() => import("../pages/Notifications"));
const Dashboard = React.lazy(() => import("../../pages/Dashboard"));

const history = createBrowserHistory();

const Navigation = () => {
  const dispatch = useDispatch();
  const showCreateBlog = useSelector((st) => st.blog.showCreateBlogModal);

  const physicianOnlyRoutes = AuthRouteManager("physician", history, [
    <Route
      exact
      path="/createPost/:blogId/post/:postId"
      component={CreatePost}
    />,
  ]);

  return (
    <Suspense
      fallback={
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "grid",
            placeItems: "center",
          }}
        >
          <Loader />
        </div>
      }
    >
      <ThemeProvider theme={theme}>
        <Router history={history} basename="/blogs">
          <Layout history={history}>
            <RootModal />

            <Login open={false} setOpen={() => history.back()} />

            <CreateBlog
              history={history}
              show={showCreateBlog}
              setShow={(show) => {
                dispatch(createBlogModal(show));
              }}
            />

            <Switch>
              <Route exact path="/" component={Home} />

              {physicianOnlyRoutes}

              <ProtectedRoute
                exact
                path="/dashboard/:blogUrlSlug/:tab"
                component={Dashboard}
              />
              <ProtectedRoute
                exact
                path="/user/dashboard"
                component={UserDashboard}
              />
              <Route exact path="/viewpost/:slugId" component={ViewPost} />
              <ProtectedRoute exact path="/messages" component={Chats} />
              <Route
                exact
                path="/search/:page/:type/:value?/:keywordId?"
                component={NewSearch}
              />
              <Route
                exact
                path="/blogfolio/:blogUrlSlug/:type"
                component={Blogfolio}
              />
              <ProtectedRoute
                exact
                path="/notifications"
                component={Notifications}
              />
            </Switch>
          </Layout>
        </Router>
      </ThemeProvider>
    </Suspense>
  );
};

export default Navigation;
